import { Route } from '@angular/router';
import { authGuard } from '@aggregator/core';
import { pageRoutes } from '@aggregator/pages';

export const appRoutes: Route[] = [
  {
    path: 'auth',
    loadComponent: () => import('./pages').then(m => m.AuthPage),
    title: 'UIMS - Aggregator',
  },
  {
    path: 'set-password',
    loadComponent: () => import('./pages').then(m => m.SetPasswordPage),
    title: 'UIMS - Aggregator',
  },
  {
    path: '',
    loadComponent: () => import('./pages/page.component').then(m => m.PageComponent),
    canActivate: [authGuard],
    title: 'UIMS - Aggregator',
    children: [...pageRoutes],
  },
];
